import { Link } from "react-router-dom";
import { Header } from "../components/Header";

export function NotFound() {
  return (
    <>
      <Header />
      <main>
        <section className="card">
          <h2>Page not found</h2>
          <p className="card-desc">
            The page you requested does not exist.
          </p>
          <Link to="/">← Dashboard</Link>
        </section>
      </main>
    </>
  );
}
